import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../Actions/axios.config';

export const resourceKeys = {
    all: ['resources'],
};

export const useResources = () => {
    return useQuery({
        queryKey: resourceKeys.all,
        queryFn: async () => {
            const { data } = await axios.get('/resource/getresources');
            return data.resources;
        },
    });
};

export const useUploadResource = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (newResource) => axios.post('/resource/createresource', newResource),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: resourceKeys.all });
        },
    });
};
